/* =============================================================================
   Thirsty Threads - Recently Viewed placeholder sweep
   Added 9 September 2026. Rewritten 2 October 2026.

   WHY THIS EXISTS
   Ella renders the "Recently Viewed Products" block as 10 skeleton cards and
   only fills it when the block scrolls into view (IntersectionObserver). It
   removes the block only when the shopify_recently_viewed cookie is empty,
   and it excludes the product you are looking at. So a visitor landing on a
   PDP from a Meta ad has one cookie entry - the current product - and the
   block sits there as 10 "Example product title" skeletons forever.

   2 Oct 2026 rewrite: the old version removed any block still showing
   skeletons 6 seconds after page load. Because Ella only fills the block when
   it is scrolled into view, that also deleted perfectly good Recently Viewed
   blocks for anyone who had not reached the bottom of the page within 6s -
   i.e. almost everyone on collection pages. Now:
     1. If there is nothing to show (no cookie entries other than the current
        product), the block is removed immediately - no skeleton flash.
     2. Otherwise it is left for Ella to fill when it scrolls into view, and
        only removed if it has been on screen for 6s and is still empty
        (e.g. every remembered product has since been deleted).
   ============================================================================= */
(function () {
  var COOKIE = 'shopify_recently_viewed';
  var ON_SCREEN_GRACE = 6000;

  function readHandles() {
    var raw = '';
    var match = document.cookie.match(new RegExp('(?:^|; )' + COOKIE + '=([^;]*)'));
    if (match) raw = match[1];
    if (!raw) {
      try { raw = localStorage.getItem(COOKIE) || ''; } catch (e) { raw = ''; }
    }
    try { raw = decodeURIComponent(raw); } catch (e) { /* keep raw */ }
    return raw.split(/[\s+]+/).filter(Boolean);
  }

  function currentHandle() {
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function hasReal(block) {
    return !!block.querySelector('.product-item:not(.product-item--loadingNoInfo)');
  }

  function hasSkeleton(block) {
    return !!block.querySelector('.product-item--loadingNoInfo');
  }

  function removeBlock(block) {
    var section = block.closest('.shopify-section') || block;
    if (section.parentNode) section.parentNode.removeChild(section);
  }

  function watch(block) {
    if (!('IntersectionObserver' in window)) return;
    var timer = null;
    var io = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      if (hasReal(block)) { io.disconnect(); clearTimeout(timer); return; }
      if (entry.isIntersecting) {
        if (!timer) {
          timer = setTimeout(function () {
            if (!hasReal(block) && hasSkeleton(block)) removeBlock(block);
            io.disconnect();
          }, ON_SCREEN_GRACE);
        }
      } else if (timer) {
        clearTimeout(timer);
        timer = null;
      }
    });
    io.observe(block);
  }

  function init() {
    var blocks = document.querySelectorAll('[id*="recently-viewed"]');
    if (!blocks.length) return;

    var here = currentHandle();
    var others = readHandles().filter(function (h) { return h !== here; });

    Array.prototype.forEach.call(blocks, function (block) {
      if (hasReal(block) || !hasSkeleton(block)) return;
      if (!others.length) {
        removeBlock(block);
        return;
      }
      watch(block);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
